import { handleUnauthorized } from './session';

type ChatMessage = {
  type: string;
  content?: string;
  created?: number;
  session_id?: string | number;
  [key: string]: any;
};

export const startChat = (
  signal: AbortSignal,
  siteId: string | number,
  sessionId: string | number,
  message: string,
  token: string,
  onMessage: (message: ChatMessage) => void,
) => {
  const encodeMessage = encodeURIComponent(message);

  return fetch(
    `${AI_PREFIX}/chat/sse?site_id=${siteId}&session_id=${sessionId}&user_message=${encodeMessage}&stream_token=${token}`,
    {
      method: 'GET',
      headers: {
        Accept: 'text/event-stream, application/json', // 允许两种类型
      },
      signal,
    },
  )
    .then(async (response) => {
      if (response.status === 401) {
        handleUnauthorized();
        return;
      }

      const contentType = response.headers.get('content-type') || '';
      const streamToken = response.headers.get('x-stream-token');

      if (streamToken) {
        onMessage({
          type: 'streamToken',
          content: streamToken,
          created: +new Date(),
          session_id: sessionId,
        });
      }

      if (contentType.includes('event-stream')) {
        // 处理 SSE 流
        const reader = response.body?.getReader();
        if (!reader) throw new Error('Empty response body');
        return reader;
      } else if (contentType.includes('json')) {
        // 处理 JSON
        const data = await response.json();
        throw new Error(data.msg);
      }
    })
    .then((reader) => {
      if (!reader) return;

      const decoder = new TextDecoder();
      let buffer = '';

      if (message === 'test error') {
        // return onMessage(
        //   'error',
        //   'Something went wrong. Please try again later.',
        // );
        const random = Math.random();
        if (random >= 0.5) {
          return onMessage({
            type: 'error',
            content: 'network error',
            created: +new Date(),
            session_id: sessionId,
          });
        }
      }

      function processText(text: string) {
        buffer += text;
        let newlineIndex;
        while ((newlineIndex = buffer.indexOf('\n')) >= 0) {
          const line = buffer.slice(0, newlineIndex).trim();
          buffer = buffer.slice(newlineIndex + 1);

          if (line.startsWith('data:')) {
            // 逐步写入

            // 结束信号
            if (line.includes('[DONE]')) {
              onMessage({
                type: 'done',
                content: 'done',
                created: +new Date(),
                session_id: sessionId,
              });
              break;
            }

            // 错误信息捕获
            if (line.includes('[ERROR]')) {
              onMessage({
                type: 'error',
                content: '[ERROR]',
                created: +new Date(),
                session_id: sessionId,
              });
              break;
            }

            const eventData = line.slice(5).trim();
            const parsedData = JSON.parse(eventData);

            // 普通文本
            if (parsedData.type === 'message') {
              onMessage(parsedData);
            }
            // 流式传输表单
            if (parsedData.type === 'tracking_event') {
              onMessage(parsedData);
            }
            // 建议
            if (parsedData.type === 'suggestion') {
              onMessage(parsedData);
            }
            // 生成表单进程
            if (parsedData.type === 'plan_stage_progress') {
              onMessage(parsedData);
            }
            // 生成网站列表
            if (parsedData.type === 'spider_result') {
              onMessage(parsedData);
            }
            // 生成报告
            if (parsedData.type === 'lift_report') {
              onMessage(parsedData);
            }
            // plan 开始标识符
            if (parsedData.type === 'system_message') {
              onMessage(parsedData);
            }
          }
        }
      }
      async function read() {
        const { done, value } = await reader.read();
        if (done) return true;
        const chunk = decoder.decode(value, { stream: true });
        processText(chunk);
        await read();
      }
      return read();
    })
    .catch((error) => {
      console.log('sse error', error);

      return onMessage({
        type: 'error',
        content: error.message,
        created: +new Date(),
        session_id: sessionId,
      });
    });
};
